import { useEffect, useState } from "react";
import { authedFetch } from "./api-client";

/**
 * /api/auth/me doesn't include roles, so we probe the cheapest admin
 * endpoint (GET /admin/users) and flip true on 200. 403/network errors
 * leave it false. Used by AppLayout to gate AdminFooterMount.
 */
export function useIsAdmin(): boolean {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    let cancelled = false;
    authedFetch("/admin/users")
      .then((r) => {
        if (cancelled) return;
        if (r.ok) setIsAdmin(true);
      })
      .catch(() => {
        // Silent — non-admins or offline don't see the toggle.
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return isAdmin;
}
